export default {
  data() {
    return {
      formattedOptions: ""
    };
  },
  props: {
    address: String,
    input: {
      type: [Number, String]
    },
    apartment: {
      type: [Number, String]
    },
    floor: {
      type: [Number, String]
    },
    payment: String,
    totalPrice: Number,
    change: {
      type: [Number, String]
    },
    regularSticks: Number,
    animals: {
      type: [Array, String]
    },
    options: {
      type: [Array, String]
    },
    note: String,
    formattedDate: Array
  },
  methods: {
    optionFormat(animals, optionsDoor) {
      if (animals.length > 0) {
        const dog = animals.find(item => item === "dog") ? "У меня есть собака." : "";
        const cat = animals.find(item => item === "cat") ? "У меня есть кошка." : "";
        this.formattedOptions = `${dog ? dog + " " : ""}${cat ? cat + " " : ""}`;
      }
      if (optionsDoor.length > 0) {
        this.formattedOptions += optionsDoor.join(". ") + ".";
      }
    }
  },
  mounted() {
    this.optionFormat(this.animals, this.options);
  }
};